"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationWorkOrder',
  data: function data() {
    return {
      loading: false,
      submitting: false,
      createVisible: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: '',
        workOrderType: '',
        status: ''
      },
      tableData: {
        data: [],
        total: 0
      },
      projects: [],
      staffs: [],
      createForm: {
        projectId: '',
        workOrderType: 'install',
        title: '',
        content: '',
        serviceAddress: '',
        contactName: '',
        contactMobile: ''
      },
      types: [{
        value: 'measuring',
        label: '量房'
      }, {
        value: 'delivery',
        label: '送货'
      }, {
        value: 'install',
        label: '安装'
      }, {
        value: 'repair',
        label: '维修'
      }, {
        value: 'after_sale',
        label: '售后'
      }, {
        value: 'camera',
        label: '监控'
      }],
      statuses: [{
        value: 'pending_dispatch',
        label: '待派工'
      }, {
        value: 'pending_confirm',
        label: '待确认'
      }, {
        value: 'pending_appointment',
        label: '待预约'
      }, {
        value: 'executing',
        label: '执行中'
      }, {
        value: 'pending_acceptance',
        label: '待验收'
      }, {
        value: 'completed',
        label: '已完成'
      }, {
        value: 'cancelled',
        label: '已取消'
      }],
      statusTag: {
        pending_dispatch: 'warning',
        pending_confirm: 'warning',
        pending_appointment: '',
        executing: '',
        pending_acceptance: 'success',
        completed: 'success',
        cancelled: 'info'
      }
    };
  },
  created: function created() {
    this.loadOptions();
    this.getList();
  },
  methods: {
    count: function count(status) {
      return this.tableData.data.filter(function (item) {
        return item.workOrder.status === status;
      }).length;
    },
    typeText: function typeText(value) {
      var found = this.types.find(function (item) {
        return item.value === value;
      });
      return found ? found.label : value;
    },
    statusText: function statusText(value) {
      var found = this.statuses.find(function (item) {
        return item.value === value;
      });
      return found ? found.label : value;
    },
    actionText: function actionText(action, status) {
      if (action === 'accept' && status === 'executing') return '提交完工';
      return {
        dispatch: '派工',
        confirm: '确认',
        appoint: '预约',
        accept: '验收',
        reopen: '退回',
        cancel: '取消'
      }[action] || action;
    },
    loadOptions: function loadOptions() {
      var _this = this;
      (0, _decoration.decorationProjectListApi)({
        page: 1,
        limit: 100
      }).then(function (data) {
        _this.projects = data && data.list || [];
      }).catch(function () {});
      (0, _decoration.decorationLeadStaffOptionsApi)().then(function (data) {
        _this.staffs = data || [];
      }).catch(function () {});
    },
    getList: function getList() {
      var _this2 = this;
      this.loading = true;
      (0, _decoration.decorationWorkOrderListApi)(this.searchForm).then(function (data) {
        _this2.tableData.data = data.list || [];
        _this2.tableData.total = data.total || 0;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        page: 1,
        limit: this.searchForm.limit,
        keywords: '',
        workOrderType: '',
        status: ''
      };
      this.getList();
    },
    handleSizeChange: function handleSizeChange(value) {
      this.searchForm.limit = value;
      this.searchForm.page = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.searchForm.page = value;
      this.getList();
    },
    openCreate: function openCreate() {
      this.createForm = {
        projectId: this.projects[0] && this.projects[0].id || '',
        workOrderType: 'install',
        title: '',
        content: '',
        serviceAddress: '',
        contactName: '',
        contactMobile: ''
      };
      this.createVisible = true;
    },
    createOrder: function createOrder() {
      var _this3 = this;
      if (!this.createForm.projectId || !this.createForm.title) {
        this.$message.warning('请选择工地并填写标题');
        return;
      }
      this.submitting = true;
      (0, _decoration.decorationWorkOrderCreateApi)(this.createForm).then(function () {
        _this3.$message.success('服务工单已开立');
        _this3.createVisible = false;
        _this3.getList();
      }).finally(function () {
        _this3.submitting = false;
      });
    },
    runAction: function runAction(row, action) {
      var _this4 = this;
      var payload = {
        action: action,
        providerType: 'staff'
      };
      var run = function run() {
        (0, _decoration.decorationWorkOrderActionApi)(row.workOrder.id, payload).then(function () {
          _this4.$message.success('工单已更新');
          _this4.getList();
        });
      };
      if (action === 'dispatch') {
        this.$prompt('请输入派工职员ID', '派工', {
          inputValue: this.staffs[0] && String(this.staffs[0].id)
        }).then(function (_ref) {
          var value = _ref.value;
          payload.providerId = Number(value);
          run();
        }).catch(function () {});
        return;
      }
      if (action === 'appoint') {
        payload.appointmentStart = "".concat(new Date().toISOString().slice(0, 10), " 09:00:00");
        payload.appointmentEnd = "".concat(new Date().toISOString().slice(0, 10), " 18:00:00");
      }
      if (action === 'accept' && row.workOrder.status === 'executing') {
        payload.resultText = '后台登记完工';
      }
      this.$confirm("\u786E\u8BA4".concat(this.actionText(action, row.workOrder.status), "\uFF1F"), '服务工单', {
        type: 'warning'
      }).then(run).catch(function () {});
    }
  }
};